import {ActionMenuContext} from '#/components/actionmenu/action-menu';
import {ActionMenuSection} from '#/components/actionmenu/types';
import Map from '#/components/map/component';
import {useQueryNavigationActions} from '#/hooks/use-query-navigation-actions';
import {MapIcon} from '@heroicons/react/24/solid';
import {FunctionComponent, useContext} from 'react';
import {useTranslation} from 'react-i18next';

export const ActionMenuContentSectionMap: FunctionComponent = () => {
  const {land} = useContext(ActionMenuContext);

  const {t} = useTranslation('translation');

  const {openLandOnMap} = useQueryNavigationActions();
  const onClick = () => {
    openLandOnMap(land, ActionMenuSection.INFORMATION);
  };

  return (
    <div className='h-[300px] relative rounded-xl overflow-hidden p-0 group/action-menu-map'>
      <div className='w-full h-full pointer-events-none'>
        <Map animate={false} showNavigation={false} displayOnlySelectedLand={true} />
      </div>

      <button
        onClick={onClick}
        className={
          'w-fit flex items-center gap-2 px-5 py-3 rounded-full bg-deepblue shadow-2xl hover:scale-105 transition-all ease-in-out cursor-pointer whitespace-nowrap pointer-events-auto absolute top-2 right-2'
        }
      >
        <MapIcon className='w-4 h-4 fill-white stroke-transparent' />
        <span className='text-sm text-white font-semibold'>{t('actions.openInMap')}</span>
      </button>
    </div>
  );
};
